import { render, staticRenderFns } from "./ManualImportParkedDomainPage.vue?vue&type=template&id=6281eaf4&scoped=true&"
import script from "./ManualImportParkedDomainPage.vue?vue&type=script&lang=js&"
export * from "./ManualImportParkedDomainPage.vue?vue&type=script&lang=js&"
import style0 from "./ManualImportParkedDomainPage.vue?vue&type=style&index=0&id=6281eaf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6281eaf4",
  null
  
)

export default component.exports